import { Injectable } from '@angular/core';
import { EventsBlueprint } from './events-blueprint';
import { Store } from '@ngrx/store';
import { LookingAtProperties } from 'src/app/state/entities/component-properties-dto/looking-at.properties.dto';
import { entityActions } from 'src/app/state/entities/entity.actions';
import { EntityType, Components, CollisionType } from 'src/app/state/entities/entity.model';
import { Vector3 } from 'three';
import { generateUUID } from 'three/src/math/MathUtils.js';
import { EventsWebsocketService } from '../../../services/entities/events-websocket.service';

@Injectable({
  providedIn: 'root'
})
export class TestAvatarsService extends EventsBlueprint {
  override prompt = "spiral"
  constructor(
    private store: Store,
    private websocketService: EventsWebsocketService,
  ) {
    super()
  }

  override start(): void {
    this.avatar()
  }

  avatar() {
    this.store.dispatch(
      entityActions.netCreated({
        entity: {
          id: generateUUID(),
          type: EntityType.UserAvatar,
          ownerId: "self",
          components: [Components.lookingAt],
          coord: new Vector3(10, 0, 0),
          componentProperties: {
            LookingAt: {
              target: new Vector3(0,0,0)
            } as LookingAtProperties
          },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(),
        },
      }),
    );
  }
}
